import { render, staticRenderFns } from "./selectedItems.vue?vue&type=template&id=4dcc1247&scoped=true&"
import script from "./selectedItems.vue?vue&type=script&lang=js&"
export * from "./selectedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc1247",
  null
  
)

export default component.exports